import { Route, Routes } from "react-router-dom"
import LibraryHome from '../Library/views/library_home'
import LibrarySearch from '../online_public_catalog_query_construction/views/Search'
import SearchFunction from '../online_public_catalog_query_construction/views/SearchFunction'
import BinSearchFunction from '../online_public_catalog_query_construction/views/bib_search_function'

import CategorizationGroupONE from '../online_public_catalog_query_construction/views/CategorizationGroupONE'
import CategorizationGroupTWO from '../online_public_catalog_query_construction/views/CategorizationGroupTWO'
import CollectionSearch from '../online_public_catalog_query_construction/views/collection_search'
import LibraryCollectionSearch from '../Library/views/library_collection_search'
import News from "../news/views/News"
import QuestionAndAnswer from "../question_and_answer/views/question_and_answer"
import New from "../news/views/New"
// import BSTable from './components/BSTable'
import NewArrivalsListShow from "./views/new_arrivals_list_show"
import BibSearchFunction from '../online_public_catalog_query_construction/views/bib_search_function'
import SearchBar from '../online_public_catalog_query_construction/views/search_bar'
import NewsTypeNew from "../news/views/NewsType"
import OnlinePublicCatalogQueryConstructionNews from '../online_public_catalog_query_construction/views/online_public_catalog_query_construction_news'

const MainRoute = (
    {
        propsPath = ""
    }
) => {

    return (<>
        <Routes>
            <Route index element={<BibSearchFunction prefixRoute={'/online_public_catalog_query_construction'} />} />
            <Route path='collection_search' element={<LibraryCollectionSearch />} />
            <Route path='search_bar' element={<SearchBar />} />
            <Route path='bib_search_function' element={<BibSearchFunction />} />
            <Route path='new' element={<New />} />
            <Route path='news_setting' element={<News />} />
            <Route path='search' element={<LibrarySearch />} />
            <Route path='search_function' element={<SearchFunction />} />
            <Route path={'question_and_answer'} element={<QuestionAndAnswer />} />
            <Route path='news_type' element={<NewsTypeNew />} />
            <Route path='news' element={<OnlinePublicCatalogQueryConstructionNews  showChart={false} />} />
            <Route path='display_list' element={<NewArrivalsListShow />} />
        </Routes>
    </>)
}
export default MainRoute

